// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3i_kC","type":"styles_type__2qYnO","choices":"styles_choices__1r5pc"};